import type { ReactNode } from 'react'
import { cn } from '@/shared/ui/cn'

export type RegisterStepShellProps = {
  children: ReactNode
  className?: string
  fullBleed?: boolean
}

export function RegisterStepShell({ children, className, fullBleed = false }: RegisterStepShellProps) {
  return (
    <main
      className={cn(
        fullBleed
          ? 'mx-auto flex w-full max-w-none flex-1 flex-col gap-8 px-4 pb-6 pt-12'
          : 'mx-auto flex w-full max-w-2xl flex-1 flex-col gap-8 px-4 py-10 sm:px-6 lg:py-14',
        '[&_[data-slot=label]]:text-lg',
        '[&_[data-slot=checkbox]]:size-5 [&_[data-slot=checkbox]_svg]:size-4',
        '[&_[data-slot=input]]:h-12 [&_[data-slot=input]]:text-lg',
        '[&_[data-slot=select-trigger]]:h-12 [&_[data-slot=select-trigger]]:text-lg',
        '[&_[data-slot=button][data-size=default]]:h-12 [&_[data-slot=button][data-size=default]]:text-lg',
        className,
      )}
    >
      {children}
    </main>
  )
}
